import { IAuthData, IAuthAction } from './types';

export const reducer = (state: IAuthData, action: IAuthAction): IAuthData => {
  switch (action.type) {
    case 'AUTH_INITIALIZED': {
      return {
        ...state,
        isAuthInitialized: true,
      };
    }

    case 'SET_ME': {
      const { me } = action.data;

      const isActiveOperator = me.roles.some(
        (role) => role.alias === 'active_operator'
      );

      return {
        ...state,
        me: action.data.me,
        isAuthInitialized: true,
        isActiveOperator,
        isOwner: me.is_owner,
      };
    }

    case 'DROP_ALL_DATA':
      return {
        ...state,
        me: null,
        tokens: null,
        error: null,
      };

    case 'SET_ERROR':
      return {
        ...state,
        error: action.data.error,
      };

    case 'CLEAR_ERROR':
      return {
        ...state,
        error: null,
      };

    case 'SET_TOKENS': {
      if (!action.data) {
        console.error('You did not provided tokens to reducer');
        return state;
      }

      const { tokens } = action.data;

      return {
        ...state,
        tokens,
      };
    }
    case 'SET_PERMISSIONS': {
      if (!action.data) {
        console.error('You did not provided permissions to reducer');
        return state;
      }

      const { permissions } = action.data;

      return {
        ...state,
        permissions,
      };
    }
    default:
      console.error('You are using not existing action type');
      return state;
  }
};
